import React, { PureComponent } from 'react';
import { string, func, bool, number, shape } from 'prop-types';
import { connectToggleRefinement } from 'react-instantsearch-core';
import { ListItem } from 'components';
import FilterCollapsePanel from '../FilterCollapsePanel/FilterCollapsePanel';
import './ToggleRefinement.scss';

class ToggleRefinement extends PureComponent {
    static propTypes = {
        className: string,
        attribute: string.isRequired,
        count: shape({
            checked: number,
            unchecked: number,
        }),
        currentRefinement: bool.isRequired,
        refine: func.isRequired,
        title: string,
        label: string.isRequired,
        value: string, // eslint-disable-line react/no-unused-prop-types
        canRefine: bool,
        onFilterSelected: func.isRequired,
    };

    static defaultProps = {
        canRefine: false,
        className: null,
        count: 0,
        value: 'true',
        title: null,
    };

    handleCheckboxClick = () => {
        const { refine, currentRefinement, onFilterSelected } = this.props;
        refine(!currentRefinement);
        if (currentRefinement === false) {
            onFilterSelected({ value: true });
        }
    };

    render() {
        const {
            className,
            title,
            label,
            refine,
            currentRefinement,
            attribute,
            count,
            canRefine,
            ...otherProps
        } = this.props;

        if (!canRefine) return null;

        return (
            <FilterCollapsePanel
                className={className}
                label={title || label}
                dataQa={attribute}
            >
                <ListItem
                    {...otherProps}
                    className="toggle-refinement__checkbox"
                    value={attribute}
                    label={label}
                    checked={currentRefinement}
                    onClick={this.handleCheckboxClick}
                    count={count.unchecked}
                    disabled={!canRefine}
                />
            </FilterCollapsePanel>
        );
    }
}

export default connectToggleRefinement(ToggleRefinement);
